import React from 'react';

class SiteInfo extends React.Component {
    render() {
      return (
        <p>Welcome to { this.props.name }</p>
      );
    }
  }

  export default SiteInfo;